export type InvoiceLineItem = {
  price: number
  taxRate?: string
  id: number
  invoiceId: number
  description?: string
  quantity?: number
}

export type InvoiceAttributes = {
  createdAt: string
  funeralId?: number
  issuedDate: string | null
  paymentProvider: string
  paidOn?: string | null
  paidBy?: 'dwp' | 'other'
  reference?: string
  externalReferenceType?: 'xero' | 'compass'
  externalReferenceId?: string
  paymentProviderInvoiceId?: string
  probateCaseId?: number
  lineItems: InvoiceLineItem[]
}

export type Invoice = {
  id: number
  attributes: InvoiceAttributes
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const invoiceTotalPrice = (invoice: Invoice) =>
  invoice.attributes.lineItems.reduce(
    (acc, lineItem) => acc + lineItem.price,
    0
  )

export type FuneralInvoice = {
  amount: number | ''
  date: string | null
  externalReferenceId: string
  paidBy: 'dwp' | 'other'
  reference: string
  isPaid?: 'yes' | 'no'
}

/** This should match the server const in server/src/funeral-plans/api/config/constants/index.ts */
export const FUNERAL_PLAN_INVOICE_LINE_ITEM_DESCRIPTION = {
  payment_in_full: 'payment in full',
  instalment: 'instalment',
  refund: 'refund',
  refund_in_progress: 'refund in progress',
  dispute_funds_withdrawn: 'dispute funds withdrawn',
  /** A lump-sum payment for a celebration added after the plan was bought */
  celebration: 'celebration',
} as const
